import { defaultStore } from '../config'
import { stores } from '../../translations'

/**
 * Подключаем ассеты bourjois в игре platform только на RU store
 * */
export const isPlatformBourjoisAssets = (store = defaultStore) => {
  const startDate = new Date('2026-09-28T12:00:00')
  const endDate = new Date('2026-11-09T01:59:59+03:00')
  const now = new Date()
  const isBourjoisGameActive = now >= startDate && now <= endDate

  return isBourjoisGameActive && store === stores.ru
}
